import Hero from '../components/Hero.jsx';
import Ticker from '../components/Ticker.jsx';
import SnapPage from '../components/SnapPage.jsx';

export default function HomePage() {
  return (
    <SnapPage>
      <Hero variant="slate" />
      <Ticker />
    </SnapPage>
  );
}
